// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Html5QrcodeScanner } from "html5-qrcode";

// export default function MerchantScannerScreen() {
//   const navigate = useNavigate();
//   const [merchantId, setMerchantId] = useState("");
//   const [scanResult, setScanResult] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [statusMessage, setStatusMessage] = useState("");

//   // 1. Fetch Merchant ID dynamically from LocalStorage matrix
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           setMerchantId(parsed.merchant.user_id);
//         } else if (parsed?.user_id) {
//           setMerchantId(parsed.user_id);
//         }
//       } else {
//         setMerchantId("CMV9A117EAC"); // Standard fallback
//       }
//     } catch (e) {
//       console.error("Error reading data layer path inside Scanner:", e);
//       setMerchantId("CMV9A117EAC");
//     }
//   }, []);

//   // 2. Initialize Camera Scanner Lens Framework
//   useEffect(() => {
//     const scanner = new Html5QrcodeScanner("reader", {
//       fps: 10,
//       qrbox: { width: 250, height: 250 },
//       rememberLastUsedCamera: true,
//     });

//     scanner.render(
//       (decodedText) => {
//         // Stop scanning when a result is registered to prevent pipeline choke loops
//         scanner.clear();
//         handleCustomerCheckIn(decodedText);
//       },
//       (error) => {
//         // Internal logger for frame sequence missing data points
//         console.warn(error);
//       }
//     );

//     return () => {
//       scanner.clear().catch((err) => console.error("Scanner failed cleaning resource closure", err));
//     };
//   }, [merchantId]);

//   // 3. Automated Check-In Processing Loop Engine
//   const handleCustomerCheckIn = async (scannedCustomerId) => {
//     setScanResult(scannedCustomerId);
//     setIsProcessing(true);
//     setStatusMessage("Validating customer security pass...");

//     try {
//       const formdata = new FormData();
//       formdata.append("merchant_id", merchantId);
//       formdata.append("customer_id", scannedCustomerId);

//       const response = await fetch("https://countmyvisit.com/Apis/merchant_checkin_handler.php", {
//         method: "POST",
//         body: formdata,
//       });

//       const resText = await response.text();
//       const cleanString = resText.replace("DATABASE CONNECTED", "").trim();
//       const data = JSON.parse(cleanString);

//       if (data.success) {
//         setStatusMessage(`✅ Check-In Successful! points updated.`);
//         alert(`Success! Customer checked-in.\nMessage: ${data.message || "Done"}`);
//       } else {
//         setStatusMessage(`❌ Action Denied: ${data.message || "Failed verification"}`);
//       }
//     } catch (error) {
//       console.error("Transmission error across gateway nodes:", error);
//       setStatusMessage("⚠️ Core sync error. Please try again.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');
//         * { font-family: 'Plus Jakarta Sans', sans-serif; box-sizing: border-box; }
//         #reader { border: none !important; width: 100% !important; }
//         #reader__dashboard_section_csr button {
//           background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white;
//           border: none; padding: 10px 20px; border-radius: 10px; font-weight: 700; cursor: pointer; margin: 10px 0;
//         }
//       `}</style>

//       {/* TOP NAVIGATION HEADER */}
//       <div style={styles.navBar}>
//         <div style={styles.navBrand}>⚡ Merchant Scan Station</div>
//         <button style={styles.backBtn} onClick={() => navigate(-1)}>
//           Dashboard
//         </button>
//       </div>

//       <div style={styles.card}>
//         <div style={styles.cardAccent} />
        
//         <div style={styles.header}>
//           <h1 style={styles.logo}>Check-In Terminal</h1>
//           <p style={styles.subtitle}>Active Merchant ID: <span style={{color: '#ff8c42'}}>{merchantId}</span></p>
//         </div>

//         {/* CAMERA SCANNER INJECTION PANEL */}
//         <div style={styles.qrOuterWrapper}>
//           <div id="reader" style={{ overflow: "hidden", borderRadius: "16px" }}></div>
//         </div>

//         {/* DYNAMIC PIPELINE STATUS CARD */}
//         {scanResult && (
//           <div style={{ ...styles.statusCard, backgroundColor: isProcessing ? "#f8fafc" : "#fff7ed" }}>
//             <span style={styles.urlLabel}>LIVE ENGINE STATUS:</span>
//             <p style={{ ...styles.urlText, fontWeight: "700", marginTop: "4px" }}>{statusMessage}</p>
//             <p style={{ ...styles.urlText, fontSize: "11px", color: "#94a3b8", marginTop: "8px" }}>
//               Scanned Payload: {scanResult}
//             </p>
            
//             {!isProcessing && (
//               <button 
//                 style={{ ...styles.button, height: "40px", marginTop: "12px", fontSize: "13px" }}
//                 onClick={() => window.location.reload()}
//               >
//                 🔄 Reset Terminal Camera
//               </button>
//             )}
//           </div>
//         )}

//         <div style={styles.footer}>
//           <p style={styles.footerHighlight}>Align Customer QR inside the framework grid</p>
//           <small style={styles.poweredBy}>Powered By countmyvisit.com</small>
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: "24px",
//   },
//   navBar: {
//     width: "100%",
//     maxWidth: "430px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     background: "#ffffff",
//     padding: "14px 20px",
//     borderRadius: "16px",
//     boxShadow: "0 4px 15px rgba(15, 23, 42, 0.04)",
//     marginBottom: "24px",
//     border: "1px solid #e2e8f0",
//   },
//   navBrand: { fontSize: "14px", fontWeight: "700", color: "#0f172a" },
//   backBtn: {
//     background: "#f1f5f9", border: "none", padding: "8px 14px",
//     borderRadius: "10px", fontSize: "12px", fontWeight: "700",
//     color: "#475569", cursor: "pointer", transition: "0.2s",
//   },
//   card: {
//     width: "100%", maxWidth: "430px", background: "#ffffff",
//     borderRadius: "32px", padding: "40px 32px", textAlign: "center",
//     boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
//     position: "relative", overflow: "hidden", border: "1px solid #f1f5f9",
//   },
//   cardAccent: {
//     position: "absolute", top: 0, left: 0, right: 0, height: "8px",
//     background: "linear-gradient(90deg, #ff8c42, #ff5e62)",
//   },
//   header: { marginBottom: "28px" },
//   logo: {
//     margin: 0, fontSize: "26px", fontWeight: "800", letterSpacing: "-0.5px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
//   },
//   subtitle: {
//     margin: "4px 0 0 0", color: "#64748b", fontSize: "13px",
//     fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.75px",
//   },
//   businessBox: { marginBottom: "24px" },
//   badge: {
//     display: "inline-block", background: "#fff7ed", color: "#ea580c",
//     fontSize: "10px", fontWeight: "800", padding: "4px 10px",
//     borderRadius: "20px", letterSpacing: "0.5px", marginBottom: "10px",
//   },
//   businessNameText: {
//     margin: 0, fontSize: "28px", fontWeight: "800", color: "#0f172a",
//     textTransform: "capitalize", lineHeight: "1.2",
//   },
//   scanInstruction: { margin: "8px 0 0 0", color: "#64748b", fontSize: "14px", fontWeight: "500" },
//   qrOuterWrapper: {
//     display: "flex", justifyContent: "center", alignItems: "center",
//     background: "#f8fafc", padding: "20px", borderRadius: "24px",
//     border: "2px dashed #cbd5e1", marginBottom: "28px",
//   },
//   qrBox: {
//     background: "#ffffff", padding: "12px", borderRadius: "16px",
//     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.04)",
//   },
//   footer: { marginTop: "12px" },
//   footerHighlight: { margin: 0, fontSize: "14px", fontWeight: "700", color: "#475569" },
//   poweredBy: {
//     display: "block", marginTop: "8px", color: "#94a3b8", fontSize: "11px",
//     fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px",
//   },
//   controlPanel: { width: "100%", maxWidth: "430px", textAlign: "center" },
//   button: {
//     marginTop: "12px", width: "100%", height: "54px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     color: "#ffffff", border: "none", borderRadius: "14px", cursor: "pointer",
//     fontSize: "16px", fontWeight: "600", transition: "all 0.2s ease",
//     boxShadow: "0 10px 20px -5px rgba(255, 94, 98, 0.3)",
//   },
//   statusCard: {
//     marginTop: "5px", padding: "14px", borderRadius: "14px",
//     border: "1px dashed #ff8c42", textAlign: "left", marginBottom: "20px",
//   },
//   urlLabel: { display: "block", fontSize: "10px", fontWeight: "800", color: "#64748b", letterSpacing: "0.5px" },
//   urlText: { margin: 0, fontSize: "13px", color: "#334155", wordBreak: "break-all" },
// };


// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Html5QrcodeScanner } from "html5-qrcode";

// export default function MerchantScannerScreen() {
//   const navigate = useNavigate();
//   const [merchantId, setMerchantId] = useState("");
//   const [scanResult, setScanResult] = useState(null);
//   const [isProcessing, setIsProcessing] = useState(false);
//   const [statusMessage, setStatusMessage] = useState("");
  
//   // Customer details states
//   const [customerInfo, setCustomerInfo] = useState(null);
//   const [billAmount, setBillAmount] = useState("");
//   const [visitStep, setVisitStep] = useState(1); // 1: Scanning, 2: Input Bill & Complete Visit

//   // 1. Fetch Merchant ID dynamically from LocalStorage matrix
//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("userData");
//       if (savedDataString) {
//         const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
//         const parsed = JSON.parse(cleanDataStr);
//         if (parsed?.merchant?.user_id) {
//           setMerchantId(parsed.merchant.user_id);
//         } else if (parsed?.user_id) {
//           setMerchantId(parsed.user_id);
//         }
//       } else {
//         setMerchantId("CMV9A117EAC"); // Standard fallback
//       }
//     } catch (e) {
//       console.error("Error reading data layer path inside Scanner:", e);
//       setMerchantId("CMV9A117EAC");
//     }
//   }, []);

//   // 2. Initialize Camera Scanner Lens Framework
//   useEffect(() => {
//     // Scanner lifecycle explicitly bound to step 1 (Scanning state)
//     if (visitStep !== 1) return;

//     const scanner = new Html5QrcodeScanner("reader", {
//       fps: 10,
//       qrbox: { width: 250, height: 250 },
//       rememberLastUsedCamera: true,
//     });

//     scanner.render(
//       (decodedText) => {
//         scanner.clear().catch(err => console.error(err));
//         setScanResult(decodedText);
//         fetchCustomerDetails(decodedText);
//       },
//       (error) => {
//         console.warn(error);
//       }
//     );

//     return () => {
//       scanner.clear().catch((err) => console.error("Scanner failed cleaning resource closure", err));
//     };
//   }, [visitStep]);

//   // 3. API Chain Step 1: Fetch Customer Profile Data
//   const fetchCustomerDetails = async (scannedCustomerId) => {
//     setIsProcessing(true);
//     setStatusMessage("Fetching customer identity records...");

//     try {
//       const myHeaders = new Headers();
//       myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

//       const urlencoded = new URLSearchParams();
//       urlencoded.append("customer_id", scannedCustomerId);

//       const response = await fetch("https://countmyvisit.com/Apis/get_customer_details.php", {
//         method: "POST",
//         headers: myHeaders,
//         body: urlencoded,
//       });

//       const resText = await response.text();
//       const cleanString = resText.replace("DATABASE CONNECTED", "").trim();
//       const data = JSON.parse(cleanString);

//       if (data.success) {
//         setCustomerInfo(data);
//         setStatusMessage("✅ Customer verified. Please add bill amount.");
//         setVisitStep(2); // Advance structural layer to processing input panel
//       } else {
//         setStatusMessage(`❌ Verification Failed: ${data.message || "User not found"}`);
//         alert(`Error: ${data.message || "Invalid Customer QR"}`);
//         resetTerminal();
//       }
//     } catch (error) {
//       console.error("Error fetching records:", error);
//       setStatusMessage("⚠️ Framework connection error while looking up profile.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // 4. API Chain Step 2: Push Bill Payload and Log Visit Transaction
//   const handleFinalCheckIn = async (e) => {
//     e.preventDefault();
//     if (!billAmount || isNaN(billAmount) || parseFloat(billAmount) <= 0) {
//       alert("Please enter a valid bill amount greater than 0");
//       return;
//     }

//     setIsProcessing(true);
//     setStatusMessage("Logging terminal visit logs & syncing reward engines...");

//     try {
//       const formdata = new FormData();
//       formdata.append("customer_id", scanResult);
//       formdata.append("merchant_id", merchantId);
//       formdata.append("billamount", billAmount);

//       const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
//         method: "POST",
//         body: formdata,
//       });

//       const resText = await response.text();
//       const cleanString = resText.replace("DATABASE CONNECTED", "").trim();
//       const data = JSON.parse(cleanString);

//       if (data.success) {
//         setStatusMessage(`🎉 Success! Visit #${data.current_visit} logged.`);
//         alert(`Visit added successfully!\nTotal Visits: ${data.current_visit}`);
//         resetTerminal();
//       } else {
//         setStatusMessage(`❌ Visit Denied: ${data.message || "Failed processing code block"}`);
//         alert(`Denied: ${data.message}`);
//       }
//     } catch (error) {
//       console.error("Transmission error on add_visit gateway:", error);
//       setStatusMessage("⚠️ Critical ledger mapping synchronization timeout.");
//     } finally {
//       setIsProcessing(false);
//     }
//   };

//   // 5. Hard Reset State Matrix Helper
//   const resetTerminal = () => {
//     setScanResult(null);
//     setCustomerInfo(null);
//     setBillAmount("");
//     setStatusMessage("");
//     setVisitStep(1);
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');
//         * { font-family: 'Plus Jakarta Sans', sans-serif; box-sizing: border-box; }
//         #reader { border: none !important; width: 100% !important; }
//         #reader__dashboard_section_csr button {
//           background: linear-gradient(135deg, #ff8c42, #ff5e62); color: white;
//           border: none; padding: 10px 20px; border-radius: 10px; font-weight: 700; cursor: pointer; margin: 10px 0;
//         }
//       `}</style>

//       {/* TOP NAVIGATION HEADER */}
//       <div style={styles.navBar}>
//         <div style={styles.navBrand}>⚡ Merchant Scan Station</div>
//         <button style={styles.backBtn} onClick={() => navigate(-1)}>
//           Dashboard
//         </button>
//       </div>

//       <div style={styles.card}>
//         <div style={styles.cardAccent} />
        
//         <div style={styles.header}>
//           <h1 style={styles.logo}>Check-In Terminal</h1>
//           <p style={styles.subtitle}>Active Merchant ID: <span style={{color: '#ff8c42', fontWeight: '700'}}>{merchantId}</span></p>
//         </div>

//         {/* STEP 1: CAMERA SCANNER SECTION */}
//         {visitStep === 1 && (
//           <div style={styles.qrOuterWrapper}>
//             <div id="reader" style={{ overflow: "hidden", borderRadius: "16px" }}></div>
//           </div>
//         )}

//         {/* STEP 2: PREMIUM VISIT BILL DATA FORM SECTION */}
//         {visitStep === 2 && customerInfo && (
//           <form onSubmit={handleFinalCheckIn} style={styles.customerProfileWrapper}>
//             <div style={styles.customerHeaderCard}>
//               <div style={styles.avatarCircle}>🤵</div>
//               <h3 style={styles.custName}>{customerInfo.customer_name || "Premium Member"}</h3>
//               <p style={styles.custMeta}>📱 {customerInfo.mobile}</p>
//               <span style={styles.custBadge}>{customerInfo.status?.toUpperCase() || "ACTIVE"}</span>
//             </div>

//             <div style={styles.inputGroup}>
//               <label style={styles.fieldLabel}>ENTER TOTAL BILL AMOUNT (INR)</label>
//               <input
//                 type="number"
//                 placeholder="₹ Enter bill amount"
//                 value={billAmount}
//                 onChange={(e) => setBillAmount(e.target.value)}
//                 style={styles.billingInput}
//                 disabled={isProcessing}
//                 required
//               />
//             </div>

//             <button type="submit" disabled={isProcessing} style={styles.button}>
//               {isProcessing ? "Processing Ledger Entry..." : "🚀 Complete Visit Processing"}
//             </button>

//             <button type="button" onClick={resetTerminal} style={styles.cancelBtn}>
//               Cancel & Scan Again
//             </button>
//           </form>
//         )}

//         {/* DYNAMIC PIPELINE STATUS LOGGER */}
//         {statusMessage && (
//           <div style={{ ...styles.statusCard, backgroundColor: isProcessing ? "#f8fafc" : "#fff7ed" }}>
//             <span style={styles.urlLabel}>CORE ENGINE LOGS:</span>
//             <p style={{ ...styles.urlText, fontWeight: "700", marginTop: "4px" }}>{statusMessage}</p>
//             {scanResult && (
//               <p style={{ ...styles.urlText, fontSize: "11px", color: "#94a3b8", marginTop: "6px" }}>
//                 Target payload identifier: {scanResult}
//               </p>
//             )}
//           </div>
//         )}

//         <div style={styles.footer}>
//           <p style={styles.footerHighlight}>
//             {visitStep === 1 ? "Align Customer QR inside framework grid" : "Complete terminal check-in entries"}
//           </p>
//           <small style={styles.poweredBy}>Powered By countmyvisit.com</small>
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//     display: "flex", flexDirection: "column", alignItems: "center", padding: "24px",
//   },
//   navBar: {
//     width: "100%", maxWidth: "430px", display: "flex", justifyContent: "space-between",
//     alignItems: "center", background: "#ffffff", padding: "14px 20px", borderRadius: "16px",
//     boxShadow: "0 4px 15px rgba(15, 23, 42, 0.04)", marginBottom: "24px", border: "1px solid #e2e8f0",
//   },
//   navBrand: { fontSize: "14px", fontWeight: "700", color: "#0f172a" },
//   backBtn: {
//     background: "#f1f5f9", border: "none", padding: "8px 14px", borderRadius: "10px",
//     fontSize: "12px", fontWeight: "700", color: "#475569", cursor: "pointer",
//   },
//   card: {
//     width: "100%", maxWidth: "430px", background: "#ffffff", borderRadius: "32px",
//     padding: "40px 32px", textAlign: "center", boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
//     position: "relative", overflow: "hidden", border: "1px solid #f1f5f9",
//   },
//   cardAccent: {
//     position: "absolute", top: 0, left: 0, right: 0, height: "8px",
//     background: "linear-gradient(90deg, #ff8c42, #ff5e62)",
//   },
//   header: { marginBottom: "28px" },
//   logo: {
//     margin: 0, fontSize: "26px", fontWeight: "800", letterSpacing: "-0.5px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
//   },
//   subtitle: {
//     margin: "4px 0 0 0", color: "#64748b", fontSize: "13px", fontWeight: "600",
//     textTransform: "uppercase", letterSpacing: "0.75px",
//   },
//   qrOuterWrapper: {
//     display: "flex", justifyContent: "center", alignItems: "center", background: "#f8fafc",
//     padding: "20px", borderRadius: "24px", border: "2px dashed #cbd5e1", marginBottom: "28px",
//   },
//   customerProfileWrapper: {
//     display: "flex", flexDirection: "column", gap: "20px", textAlign: "left", marginBottom: "24px"
//   },
//   customerHeaderCard: {
//     background: "#f8fafc", padding: "16px", borderRadius: "20px", border: "1px solid #e2e8f0", textAlign: "center"
//   },
//   avatarCircle: { fontSize: "36px", marginBottom: "6px" },
//   custName: { margin: "0", fontSize: "18px", fontWeight: "800", color: "#0f172a" },
//   custMeta: { margin: "4px 0 0 0", fontSize: "14px", color: "#64748b", fontWeight: "500" },
//   custBadge: {
//     display: "inline-block", background: "#dcfce7", color: "#15803d", fontSize: "10px",
//     fontWeight: "800", padding: "3px 8px", borderRadius: "10px", marginTop: "8px", letterSpacing: "0.5px"
//   },
//   inputGroup: { display: "flex", flexDirection: "column", gap: "6px" },
//   fieldLabel: { fontSize: "11px", fontWeight: "800", color: "#64748b", letterSpacing: "0.5px" },
//   billingInput: {
//     width: "100%", height: "50px", borderRadius: "14px", border: "2px solid #cbd5e1",
//     padding: "0 16px", fontSize: "16px", fontWeight: "600", color: "#0f172a", outline: "none",
//     transition: "all 0.2s"
//   },
//   button: {
//     width: "100%", height: "54px", background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     color: "#ffffff", border: "none", borderRadius: "14px", cursor: "pointer",
//     fontSize: "16px", fontWeight: "700", boxShadow: "0 10px 20px -5px rgba(255, 94, 98, 0.3)",
//   },
//   cancelBtn: {
//     background: "transparent", border: "none", color: "#64748b", fontWeight: "700",
//     fontSize: "13px", cursor: "pointer", textAlign: "center", marginTop: "-5px"
//   },
//   statusCard: {
//     marginTop: "5px", padding: "14px", borderRadius: "14px", border: "1px dashed #ff8c42",
//     textAlign: "left", marginBottom: "20px",
//   },
//   urlLabel: { display: "block", fontSize: "10px", fontWeight: "800", color: "#64748b" },
//   urlText: { margin: 0, fontSize: "13px", color: "#334155", wordBreak: "break-all" },
//   footer: { marginTop: "12px" },
//   footerHighlight: { margin: 0, fontSize: "14px", fontWeight: "700", color: "#475569" },
//   poweredBy: {
//     display: "block", marginTop: "8px", color: "#94a3b8", fontSize: "11px",
//     fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px",
//   }
// };

import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Html5Qrcode } from "html5-qrcode";

export default function MerchantScannerScreen() {
  const navigate = useNavigate();
  const html5QrCodeRef = useRef(null);
  const scannerContainerId = "qr-reader-core-box-terminal";

  const [merchantId, setMerchantId] = useState("");
  const [scanResult, setScanResult] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  
  // Customer details states
  const [customerInfo, setCustomerInfo] = useState(null);
  const [billAmount, setBillAmount] = useState("");
  const [visitStep, setVisitStep] = useState(1); // 1: Scanning, 2: Input Bill & Complete Visit
  const [scannerReady, setScannerReady] = useState(false);

  // 1. Fetch Merchant ID dynamically from LocalStorage matrix
  useEffect(() => {
    try {
      const savedDataString = localStorage.getItem("userData");
      if (savedDataString) {
        const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
        const parsed = JSON.parse(cleanDataStr);
        if (parsed?.merchant?.user_id) {
          setMerchantId(parsed.merchant.user_id);
        } else if (parsed?.user_id) {
          setMerchantId(parsed.user_id);
        }
      } else {
        setMerchantId("CMV9A117EAC"); // Standard fallback
      }
    } catch (e) {
      console.error("Error reading data layer path inside Scanner:", e);
      setMerchantId("CMV9A117EAC");
    }
  }, []);

  // 2. Initialize Camera Scanner Component Automatically (GPay Core)
  useEffect(() => {
    if (visitStep !== 1) return;

    const startCameraInstant = async () => {
      try {
        const html5QrCode = new Html5Qrcode(scannerContainerId);
        html5QrCodeRef.current = html5QrCode;

        await html5QrCode.start(
          { facingMode: "environment" },
          {
            fps: 24, // High speed tracking
            qrbox: (width, height) => {
              const minEdge = Math.min(width, height);
              const boxSize = Math.floor(minEdge * 0.7);
              return { width: boxSize, height: boxSize };
            },
          },
          onScanSuccess,
          onScanFailure
        );
        setScannerReady(true);
      } catch (err) {
        console.error("Instant Camera Activation Failed:", err);
      }
    };

    const timer = setTimeout(() => {
      startCameraInstant();
    }, 100);

    return () => {
      clearTimeout(timer);
      stopScannerSafely();
    };
  }, [visitStep]);

  const stopScannerSafely = async () => {
    if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) {
      try {
        await html5QrCodeRef.current.stop();
        html5QrCodeRef.current = null;
        setScannerReady(false);
      } catch (err) {
        console.warn("Failed to stop camera instance safely:", err);
      }
    }
  };

  // Handle Successful QR Scan
  const onScanSuccess = async (decodedText) => {
    try {
      const audio = new Audio("https://assets.mixkit.co/active_storage/sfx/2869/2869-600.wav");
      audio.play().catch(() => {});

      setScanResult(decodedText);
      await stopScannerSafely();
      fetchCustomerDetails(decodedText);
    } catch (err) {
      console.error("Scan processing core lock error:", err);
    }
  };

  const onScanFailure = (error) => {
    // Silent
  };

  // 3. API Chain Step 1: Fetch Customer Profile Data
  const fetchCustomerDetails = async (scannedCustomerId) => {
    setIsProcessing(true);
    setStatusMessage("Fetching customer identity records...");

    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      const urlencoded = new URLSearchParams();
      urlencoded.append("customer_id", scannedCustomerId);

      const response = await fetch("https://countmyvisit.com/Apis/get_customer_details.php", {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
      });

      const resText = await response.text();
      const cleanString = resText.replace("DATABASE CONNECTED", "").trim();
      const data = JSON.parse(cleanString);

      if (data.success) {
        setCustomerInfo(data);
        setStatusMessage("✅ Customer verified. Please add bill amount.");
        setVisitStep(2); 
      } else {
        setStatusMessage(`❌ Verification Failed: ${data.message || "User not found"}`);
        alert(`Error: ${data.message || "Invalid Customer QR"}`);
        resetTerminal();
      }
    } catch (error) {
      console.error("Error fetching records:", error);
      setStatusMessage("⚠️ Framework connection error while looking up profile.");
    } finally {
      setIsProcessing(false);
    }
  };

  // 4. API Chain Step 2: Push Bill Payload and Log Visit Transaction
  const handleFinalCheckIn = async (e) => {
    e.preventDefault();
    if (!billAmount || isNaN(billAmount) || parseFloat(billAmount) <= 0) {
      alert("Please enter a valid bill amount greater than 0");
      return;
    }

    setIsProcessing(true);
    setStatusMessage("Logging terminal visit logs & syncing reward engines...");

    try {
      const formdata = new FormData();
      formdata.append("customer_id", scanResult);
      formdata.append("merchant_id", merchantId);
      formdata.append("billamount", billAmount);

      const response = await fetch("https://countmyvisit.com/Apis/add_visit.php", {
        method: "POST",
        body: formdata,
      });

      const resText = await response.text();
      const cleanString = resText.replace("DATABASE CONNECTED", "").trim();
      const data = JSON.parse(cleanString);

      if (data.success) {
        setStatusMessage(`🎉 Success! Visit #${data.current_visit} logged.`);
        alert(`Visit added successfully!\nTotal Visits: ${data.current_visit}`);
        resetTerminal();
      } else {
        setStatusMessage(`❌ Visit Denied: ${data.message || "Failed processing"}`);
        alert(`Denied: ${data.message}`);
      }
    } catch (error) {
      console.error("Transmission error on add_visit gateway:", error);
      setStatusMessage("⚠️ Critical ledger mapping synchronization timeout.");
    } finally {
      setIsProcessing(false);
    }
  };

  // 5. Hard Reset State Matrix Helper
  const resetTerminal = () => {
    setScanResult(null);
    setCustomerInfo(null);
    setBillAmount("");
    setStatusMessage("");
    setVisitStep(1);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500;600;700;800&display=swap');
        
        .scanner-layout { 
          min-height: 100vh; 
          background: #090d16; 
          color: #f8fafc; 
          padding: 24px 16px; 
          font-family: 'Plus Jakarta Sans', sans-serif; 
          display: flex; 
          flex-direction: column; 
          align-items: center; 
        }
        
        .header-section { 
          width: 100%; 
          max-width: 440px; 
          display: flex; 
          justify-content: space-between; 
          align-items: center; 
          margin-bottom: 24px; 
        }

        .back-workspace-btn { 
          background: #1e293b; 
          color: #94a3b8; 
          border: 1px solid #334155; 
          padding: 10px 16px; 
          border-radius: 14px; 
          font-weight: 600; 
          font-size: 13px;
          cursor: pointer; 
          transition: 0.2s; 
        }
        .back-workspace-btn:hover { background: #334155; color: #fff; }

        .scanner-card { 
          width: 100%; 
          max-width: 440px; 
          background: #111827; 
          border-radius: 32px; 
          padding: 28px 24px; 
          box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5); 
          border: 1px solid #1f2937; 
          text-align: center; 
        }

        /* GPay Dynamic Viewfinder Overlay Box */
        .gpay-scanner-container {
          position: relative;
          width: 100%;
          border-radius: 24px;
          overflow: hidden;
          background: #000;
          aspect-ratio: 1 / 1;
          border: 1px solid #374151;
        }

        #qr-reader-core-box-terminal {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover;
        }

        #qr-reader-core-box-terminal video {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
        }

        /* HUD Scanner target overlay */
        .scanner-hud-overlay {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          pointer-events: none;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10;
        }

        .hud-scope {
          width: 70%;
          height: 70%;
          border: 2px solid rgba(255, 255, 255, 0.15);
          border-radius: 24px;
          position: relative;
          box-shadow: 0 0 0 4000px rgba(9, 13, 22, 0.6);
        }

        /* Glowing Corners */
        .hud-scope::before, .hud-scope::after, .hud-corner-bottom::before, .hud-corner-bottom::after {
          content: '';
          position: absolute;
          width: 24px;
          height: 24px;
          border-color: #38bdf8;
          border-style: solid;
          pointer-events: none;
        }
        .hud-scope::before { top: -2px; left: -2px; border-width: 4px 0 0 4px; border-top-left-radius: 14px; }
        .hud-scope::after { top: -2px; right: -2px; border-width: 4px 4px 0 0; border-top-right-radius: 14px; }
        
        .hud-corner-bottom { position: absolute; width: 100%; height: 100%; top: 0; left: 0; }
        .hud-corner-bottom::before { bottom: -2px; left: -2px; border-width: 0 0 4px 4px; border-bottom-left-radius: 14px; }
        .hud-corner-bottom::after { bottom: -2px; right: -2px; border-width: 0 4px 4px 0; border-bottom-right-radius: 14px; }

        /* GPay Laser Animated Line */
        .laser-line {
          position: absolute;
          width: 90%;
          height: 3px;
          background: linear-gradient(90deg, transparent, #38bdf8, transparent);
          left: 5%;
          animation: laserMove 2s linear infinite;
          box-shadow: 0 0 12px #38bdf8;
          z-index: 12;
        }

        @keyframes laserMove {
          0% { top: 15%; opacity: 0; }
          10% { opacity: 1; }
          90% { opacity: 1; }
          100% { top: 85%; opacity: 0; }
        }

        .customer-header-card {
          background: #1f2937;
          border: 1px solid #374151;
          padding: 20px;
          border-radius: 20px;
          text-align: center;
          margin-bottom: 20px;
        }

        .bill-input-form input { 
          width: 100%; 
          height: 56px; 
          border: 2px solid #374151; 
          background: #090d16; 
          border-radius: 16px; 
          padding: 0 16px; 
          font-size: 22px; 
          color: white; 
          text-align: center; 
          outline: none; 
          margin-bottom: 20px; 
          transition: 0.2s; 
          font-weight: 700; 
        }
        .bill-input-form input:focus { border-color: #38bdf8; box-shadow: 0 0 0 4px rgba(56, 189, 248, 0.15); }
        
        .action-btn { width: 100%; height: 54px; border: none; border-radius: 16px; font-size: 15px; font-weight: 700; cursor: pointer; transition: 0.2s; }
        .btn-orange { background: #38bdf8; color: #090d16; }
        .btn-green { background: #10b981; color: white; }
        .btn-secondary { background: transparent; color: #9ca3af; border: none; margin-top: 12px; font-size: 13px; }

        .status-box { 
          margin-top: 20px; 
          padding: 14px; 
          border-radius: 16px; 
          background: #1f2937; 
          border: 1px dashed #374151; 
          text-align: left; 
          font-size: 13px;
        }
        * {
  -webkit-user-select: none;  /* Safari */
  -moz-user-select: none;     /* Firefox */
  -ms-user-select: none;      /* IE10+ */
  user-select: none;          /* Standard */
  -webkit-user-drag: none;    /* इमेजेस या एलिमेंट्स को ड्रैग करने से रोकने के लिए */
}
      `}</style>

      <div className="scanner-layout">
        
        {/* HEADER BLOCK */}
        <div className="header-section">
          <h2 style={{ fontSize: "17px", fontWeight: "800", color: "#fff", display: "flex", alignItems: "center", gap: "8px" }}>
            <span style={{ width: "8px", height: "8px", background: scannerReady ? "#10b981" : "#ef4444", borderRadius: "50%" }}></span>
            Check-In Terminal
          </h2>
          <button className="back-workspace-btn" onClick={() => navigate(-1)}>
            ← Cancel
          </button>
        </div>

        <div className="scanner-card">
          <p style={{ margin: "-10px 0 20px 0", color: "#6b7280", fontSize: "12px", fontWeight: "600" }}>
            ACTIVE MID: <span style={{ color: "#38bdf8" }}>{merchantId}</span>
          </p>

          {/* STEP 1: SCANNING FRAMEWORK VIEW */}
          {visitStep === 1 && (
            <>
              <div style={{ marginBottom: "20px" }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", marginBottom: "4px" }}>Align Customer QR</h3>
                <p style={{ color: "#6b7280", fontSize: "13px" }}>Hold camera steady over the pass.</p>
              </div>

              <div className="gpay-scanner-container">
                <div id={scannerContainerId}></div>
                
                <div className="scanner-hud-overlay">
                  <div className="hud-scope">
                    <div className="laser-line" />
                    <div className="hud-corner-bottom" />
                  </div>
                </div>
              </div>
            </>
          )}

          {/* STEP 2: PROFILE LOGGING FORM VIEW */}
          {visitStep === 2 && customerInfo && (
            <form onSubmit={handleFinalCheckIn} className="bill-input-form">
              <div className="customer-header-card">
                <div style={{ fontSize: "36px", marginBottom: "6px" }}>🤵</div>
                <h4 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#fff" }}>
                  {customerInfo.customer_name || "Premium Member"}
                </h4>
                <p style={{ margin: "4px 0 8px 0", fontSize: "13px", color: "#9ca3af" }}>
                  📱 {customerInfo.mobile}
                </p>
                <span style={{ background: "rgba(16, 185, 129, 0.15)", color: "#34d399", fontSize: "11px", fontWeight: "800", padding: "4px 10px", borderRadius: "20px", textTransform: "uppercase" }}>
                  {customerInfo.status || "Verified"}
                </span>
              </div>

              <label style={{ display: "block", fontSize: "11px", fontWeight: "700", marginBottom: "8px", color: "#9ca3af", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "left" }}>
                Enter Total Bill Amount (INR)
              </label>
              <input
                type="number"
                placeholder="₹ 0.00"
                value={billAmount}
                onChange={(e) => setBillAmount(e.target.value)}
                disabled={isProcessing}
                required
                autoFocus
              />

              <button type="submit" disabled={isProcessing} className="action-btn btn-green">
                {isProcessing ? "Syncing Ledger Engine..." : "🚀 Complete Visit Processing"}
              </button>

              <button type="button" onClick={resetTerminal} className="action-btn btn-secondary">
                ❌ Cancel & Scan Again
              </button>
            </form>
          )}

          {/* SYSTEM PIPELINE ENGINE LOGS */}
          {statusMessage && (
            <div className="status-box">
              <span style={{ fontSize: "10px", fontWeight: "800", color: "#6b7280", display: "block", marginBottom: "2px" }}>
                SYSTEM ENGINE LOGS:
              </span>
              <span style={{ fontWeight: "600", color: "#e5e7eb" }}>{statusMessage}</span>
              {scanResult && (
                <p style={{ margin: "4px 0 0 0", fontSize: "11px", color: "#4b5563", wordBreak: "break-all" }}>
                  Token Ref: {scanResult}
                </p>
              )}
            </div>
          )}
        </div>

      </div>
    </>
  );
}